<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>post_add</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>Modificar de Denuncia</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row align="center">
            <v-col cols="12">
              <v-text-field
                v-model="denuncia.persona"
                label="Nombre"
                :disabled="true"
              ></v-text-field>
            </v-col>
          </v-row>

          <span>
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  v-model="model.empresaId"
                  :items="empresas"
                  autocomplete="disabled"
                  item-text="nombre"
                  item-value="id"
                  label="Empresa"
                  placeholder="Seleccione una"
                  :menu-props="{ minWidth: '400' }"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  v-model="model.tipoEstadoCreditoDenunciaId"
                  :items="tipoEstadoCreditoDenuncia"
                  autocomplete="disabled"
                  item-text="descripcion"
                  item-value="id"
                  label="Estado Credito con Denuncia"
                  placeholder="Seleccione uno"
                  :menu-props="{ minWidth: '400' }"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="4">
                <v-autocomplete
                  v-model="model.motivoDenunciaId"
                  :items="motivosDenuncia"
                  autocomplete="disabled"
                  item-text="descripcion"
                  item-value="id"
                  label="Motivo Denuncia"
                  placeholder="Seleccione una"
                  :menu-props="{ minWidth: '400' }"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  v-model="model.estadoDebitoId"
                  :items="tiposEstadoDebito"
                  autocomplete="disabled"
                  item-text="descripcion"
                  item-value="id"
                  label="Estado Debito"
                  placeholder="Seleccione uno"
                  :menu-props="{ minWidth: '400' }"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <div>
                  <v-text-field
                    type="decimal"
                    v-model="model.saldoCredito"
                    label="Saldo"
                    @change="parseInput(model.saldoCredito, 'saldo')"
                  />
                </div>
              </v-col>
              <v-col cols="4">
                <div>
                  <v-text-field
                    type="decimal"
                    v-model="model.capital"
                    label="Capital"
                    @change="parseInput(model.capital, 'capital')"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="model.fechaAudiencia"
                      label="fechaAudiencia"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="model.fechaAudiencia"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="model.fechaContestacion"
                      label="fechaContestacion"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="model.fechaContestacion"
                    @input="menu3 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </span>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="altaReclamo"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
//import Vue from 'vue'
import { http } from '@/axios';
//import { addDays, format } from 'date-fns'
//import {Decimal} from 'decimal.js';

import {
  //mapState,
  mapGetters,
  mapMutations,
  //mapActions
} from 'vuex';

export default {
  data: () => ({
    saving: false,
    validando: false,
    model: {
      empresaId: 0,
      motivoDenunciaId: 0,
      tipoEstadoCreditoDenunciaId: 0,
      fechaAudiencia: null,
      fechaContestacion: null,
      motivoResumido: '',
      estadoDebitoId: 0,
    },
    empresas: [],
    creditos: [],
    motivosDenuncia: [],
    tipoDenuncia: [],
    tipoEstadoCreditoDenuncia: [],
    provincias: [],
    tiposEstadoDebito: [],
    menu2: false,
    menu3: false,
  }),
  props: {
    modo: { type: String },
    denuncia: {
      type: Object,
    },
  },
  created() {
    this.loadEmpresas();
    this.loadMotivosDenuncia();
    this.loadEstadoCreditoDenuncia();
    this.loadEstadosDebito();
    this.setOthers();

    this.denuncia.fechaAudiencia = this.$moment(
      this.model.fechaAudiencia
    ).format('YYYY-MM-DD');
    this.denuncia.fechaContestacion = this.$moment(
      this.model.fechaContestacion
    ).format('YYYY-MM-DD');
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user']),
    listCreditosActivos: function() {
      if (!this.listDeudas || this.listDeudas.length == 0) return [];
      let lista = this.listDeudas.filter(
        (i) => i.tipo == 'Credito' || i.tipo == 'Acuerdo'
      );

      return lista;
    },
  },
  watch: {
    seAsociaACredito: function() {
      this.listCargosAAplicar = [];
      this.importeCargoAAgregar = 0;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    async altaReclamo() {
      if (!this.validarAlta()) return;

      var params = {};
      params.id = this.denuncia.id;
      params.empresaId = this.model.empresaId;
      params.motivoId = this.model.motivoDenunciaId;
      params.estadoCreditoConDenunciaId = this.model.tipoEstadoCreditoDenunciaId;
      params.fechaAudiencia = this.model.fechaAudiencia;
      params.fechaContestacion = this.model.fechaContestacion;
      params.estadoDebitoId = this.model.estadoDebitoId;
      console.log(params);
      try {
        this.saving = true;
        var result = await http.put(
          'gestion/updateDenuncia',
          JSON.stringify({ parametros: params })
        );
        this.alertSuccess(
          'Se ha generado el Alta del Reclamo ' + result.entity.numero
        );
        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.saving = false;
    },
    validarAlta() {
      if (!this.model.empresaId) {
        this.alertWarning('Debe elegir una Empresa para el Reclamo.');
        return false;
      }

      if (!this.model.motivoDenunciaId) {
        this.alertWarning('Debe ingresar un Motivo para la Denuncia.');
        return false;
      }

      if (!this.model.tipoEstadoCreditoDenunciaId) {
        this.alertWarning('Debe ingresar un Estado de Credito Con Denuncia.');
        return false;
      }

      if (!this.model.fechaAudiencia) {
        this.alertWarning('Debe agregar una Fecha de Audiencia.');
        return false;
      }

      if (!this.model.fechaContestacion) {
        this.alertWarning('Debe agregar una Fecha de Contestación.');
        return false;
      }

      if (!this.model.estadoDebitoId) {
        this.alertWarning('Debe agregar un Estado Debito.');
        return false;
      }

      return true;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.empresas = result.list;
        this.empresas.push({ id: 3, nombre: 'EPB' });

        let original = this.denuncia.empresa;
        this.model.empresaId = this.empresas.filter(
          (x) => x.nombre == original
        )[0].id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMotivosDenuncia() {
      this.loading = true;
      try {
        var result = await http.get('tiposmotivodenuncia');

        this.motivosDenuncia = result.list;

        let original = this.denuncia.motivo;
        this.model.motivoDenunciaId = this.motivosDenuncia.filter(
          (x) => x.descripcion == original
        )[0].id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstadoCreditoDenuncia() {
      this.loading = true;
      try {
        var result = await http.get('tiposcreditodenuncia');

        this.tipoEstadoCreditoDenuncia = result.list;

        let original = this.denuncia.estadoCreditoConDenuncia;
        this.model.tipoEstadoCreditoDenunciaId = this.tipoEstadoCreditoDenuncia.filter(
          (x) => x.descripcion == original
        )[0].id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProvincias() {
      this.loading = true;
      try {
        var result = await http.get('provincias');

        this.provincias = result.list;

        let original = this.denuncia.provincia;
        this.model.provinciaId = this.provincias.filter(
          (x) => x.nombre == original
        )[0].id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstadosDebito() {
      this.loading = true;
      try {
        var result = await http.get('tiposdebitosdenuncia');
        this.tiposEstadoDebito = result.list;

        let original = this.denuncia.estadoDebito;

        this.model.estadoDebitoId = this.tiposEstadoDebito.filter(
          (x) => x.descripcion == original
        )[0].id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    parseInput(i, origen) {
      let n = parseFloat(i).toFixed(2);
      if (i <= 0) this.model[origen] = 0.0;
      else this.model[origen] = n;
    },
    setOthers() {
      this.model.empresaId = this.denuncia.empresaId;
      this.model.fechaContestacion = this.$moment(
        this.denuncia.fechaContestacion
      ).format('YYYY-MM-DD');
      this.model.fechaAudiencia = this.$moment(
        this.denuncia.fechaAudiencia
      ).format('YYYY-MM-DD');
      this.model.motivoResumido = this.denuncia.motivoResumido;
      this.model.saldoCredito = this.denuncia.saldoCredito;
      this.model.capital = this.denuncia.capital;
    },
  },
};
</script>
